export const DEFAULT_LANGUAGE = 'de-DE';
export const DEFAULT_FOREIGN_LANGUAGE = 'en-US';